import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "header__cart-total-details",
  "data-test": "cart-payment"
}
const _hoisted_2 = {
  class: "header__cart-total-fields",
  "data-test": "cart-subtotal-row"
}
const _hoisted_3 = { "data-test": "cart-subtotal" }
const _hoisted_4 = {
  class: "header__cart-total-fields",
  "data-test": "cart-total-row"
}
const _hoisted_5 = { "data-test": "cart-total" }

import { round } from "@/composables/round";
import { useCartStore } from "../store/cart";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CartPayment',
  setup(__props) {

const cartStore = useCartStore();

const cartTotal = computed(() => {
  const total = cartStore.cartTotal;
  return round(total);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("p", null, "Subtotal:", -1)),
      _createElementVNode("span", _hoisted_3, "$" + _toDisplayString(cartTotal.value), 1)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header__cart-divider" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "header__cart-total-fields",
      "data-test": "cart-shipping-row"
    }, [
      _createElementVNode("p", null, "Shipping:"),
      _createElementVNode("span", { "data-test": "cart-shipping" }, "Free")
    ], -1)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "header__cart-divider" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("p", null, "Total:", -1)),
      _createElementVNode("span", _hoisted_5, "$" + _toDisplayString(cartTotal.value), 1)
    ])
  ]))
}
}

})